/* eslint-disable react/no-array-index-key */
import React from "react";
import { arrayOf, bool, shape, string } from "prop-types";
import NextLink from "@insightfulscience/smart-react/NextLink";
import CardBlock, {
	CardBlockCol,
	CardBlockRow,
} from "@insightfulscience/atomic-react/r2/CardBlock";
import { useLocale } from "@insightfulscience/smart-react/i18";

import getContentProps from "../../../utils/getContentProps";
import { hasHtmEnding } from "../../../utils/url/preparePostLink";
import RichTextLink from "../../../ui/RichTextLink";

const FeaturedContectItems = ({ items = [], isImgFluid = false, ...props }) => {
	const [t] = useLocale("blog");

	return items.length ? (
		<CardBlockRow>
			{items.map((item, index) => {
				const { slug = "", externalUrl = "" } = item;
				const description = item.teaser || item.lead || item.description;
				const contentProps = getContentProps(item.sys_type, item.type);
				const DefaultLinkComponent = contentProps && contentProps.alias ? NextLink : RichTextLink;
				const LinkComponent = hasHtmEnding(slug) ? RichTextLink : DefaultLinkComponent;

				switch (item.sys_type) {
					case "pageBlog":
						return (
							<CardBlockCol key={`${item.sys_id}_${index}`}>
								<CardBlock
									titleText={item.title}
									href={contentProps && contentProps.alias ? `${contentProps.alias}/${slug}` : "#"}
									isImgFluid
									imgSrc={item.thumbnail}
									descriptionText={item.lead}
									linkButtonText={t("READ_MORE")}
									cardType={item.articleType}
									utility={{ bgColor: "white" }}
								/>
							</CardBlockCol>
						);
					default:
						return (
							<CardBlockCol key={`${item.sys_id}_${index}`}>
								<CardBlock
									isImgFluid={isImgFluid}
									LinkComponent={LinkComponent}
									cardType={contentProps?.typePlaceholder || item.type || ""}
									titleText={item.title}
									imgSrc={item.image}
									descriptionText={description}
									href={
										contentProps && contentProps.alias
											? `${contentProps.alias}/${slug}`
											: externalUrl
									}
									linkButtonText={contentProps?.linkPlaceholder || ""}
									{...props}
								/>
							</CardBlockCol>
						);
				}
			})}
		</CardBlockRow>
	) : null;
};

FeaturedContectItems.propTypes = {
	items: arrayOf(
		shape({
			sys_type: string,
			slug: string,
			externalUrl: string,
			teaser: string,
			description: string,
			title: string,
			image: string,
			type: string,
			lead: string,
			articleType: string,
			thumbnail: string,
		}),
	),
	isImgFluid: bool,
	imgClassName: string,
};

export default FeaturedContectItems;
